module.exports = __webpack_public_path__ + "img/pm_inactive.e9ffc377.svg";